import styled from 'styled-components';

export const PlanListWrap = styled.div`
    display: block;
    width: 100%;
    overflow: auto;
`;
